function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 13.4999C19 12.2697 17.7659 11.2124 16 10.7495L19 13.4999Z",
  fill: "#263D5C"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 13.4999C1 12.2697 2.2341 11.2124 4 10.7495L1 13.4999Z",
  fill: "#263D5C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 16.5C15 14.8431 12.7614 13.5 10 13.5C7.23858 13.5 5 14.8431 5 16.5M19 13.4999C19 12.2697 17.7659 11.2124 16 10.7495M1 13.4999C1 12.2697 2.2341 11.2124 4 10.7495M16 6.73611C16.6137 6.18679 17 5.3885 17 4.5C17 2.84315 15.6569 1.5 14 1.5C13.2316 1.5 12.5308 1.78885 12 2.26389M4 6.73611C3.38625 6.18679 3 5.3885 3 4.5C3 2.84315 4.34315 1.5 6 1.5C6.76835 1.5 7.46924 1.78885 8 2.26389M10 10.5C8.34315 10.5 7 9.15685 7 7.5C7 5.84315 8.34315 4.5 10 4.5C11.6569 4.5 13 5.84315 13 7.5C13 9.15685 11.6569 10.5 10 10.5Z",
  stroke: "#263D5C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgGroup = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 18",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group.bd561f93.svg";
export { ForwardRef as ReactComponent };